(function () {
    var networkErrors = document.documentElement.getAttribute("data-network-errors");

    if (!networkErrors) {
        return;
    }

    var originalFetch = window.fetch;
    var networkErrorsList = networkErrors.split(";");

    function classifyErrorFatality(e) {
        if (!(e instanceof Error)) {
            return e;
        }

        var msg = (e.message || '').toLowerCase();

        for (var i = 0; i < networkErrorsList.length; i++) {
            if (msg.indexOf(networkErrorsList[i]) !== -1) {
                e.isNonFatal = true;
            }
        }

        return e;
    }

    window.fetch = function () {
        return originalFetch.apply(window, arguments).catch(function (e) {
            var classifiedError = classifyErrorFatality(e);

            if (classifiedError.isNonFatal) {
                console.error(classifiedError);
            }

            throw classifiedError;
        });
    };
}());
